export const isOpenCatalog = () => window.location.pathname.includes('/open-catalog')
